import { axiosInstance } from './config/instance'
import {CONSOLE_API_URL, SERVER} from './config/url'

const SMS_URL = `${SERVER}/sms-service-console/api/v1/config`
const MAILING_URL = `${SERVER}/${CONSOLE_API_URL}/config`

export const providers = Object.freeze({
  async getMailingProviders() {
    const response = await axiosInstance.get(`${MAILING_URL}/providers`)
    return response.data
  },
  async saveMailingProviders(data) {
    const response = await axiosInstance.post(`${MAILING_URL}/providers`, data)
    return response.data
  },
  async getSmsProviders() {
    const response = await axiosInstance.get(`${SMS_URL}/providers`)
    return response.data
  },
  async saveSmsProviders(data) {
    const response = await axiosInstance.post(`${SMS_URL}/providers`, data)
    return response.data
  },
})
